import { Card, Typography } from "@material-ui/core";
import React from "react";
import { getSummaryIcons } from "../../constants";
import useStyles from "./SummaryCard.styles";

export default function SummaryCard({ card }) {
	const classes = useStyles();
	const summaryIcons = getSummaryIcons(card.status);
	const iconConfig = summaryIcons[card.id];
	const Icon = iconConfig.icon;

	return (
		<Card className={classes.topCard}>
			<div className={classes.metricLine}>
				<Icon className={classes.roundIcon} fill={card.color} />
				<Typography className={classes.metricValue}>{card.value}</Typography>
			</div>
			<Typography className={classes.metricDescription}>
				{card.description}
			</Typography>
			<Typography className={classes.goal}>{card.goal}</Typography>
		</Card>
	);
}
